import { render, staticRenderFns } from "./integralAllocation.vue?vue&type=template&id=7a3cf5cc&scoped=true&"
import script from "./integralAllocation.vue?vue&type=script&lang=ts&"
export * from "./integralAllocation.vue?vue&type=script&lang=ts&"
import style0 from "./integralAllocation.vue?vue&type=style&index=0&id=7a3cf5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3cf5cc",
  null
  
)

export default component.exports